import React, { useState } from "react";
import { Button, ClickAwayListener, MenuItem, Paper, Popper, Stack, TextField } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { sortByLabel } from "../../utils/sortOptions";

function fmt(d) {
  if (!d) return "";
  const dt = new Date(d);
  return dt.toISOString().slice(0, 10);
}

const PRESETS = [
  { label: "Today", days: 0 },
  { label: "Last 7 days", days: 7 },
  { label: "Last 30 days", days: 30 },
  { label: "Last 90 days", days: 90 },
  { label: "This year", days: null, custom: (today) => [new Date(today.getFullYear(), 0, 1), today] },
];

export default function DateRangePicker({ from, to, onChange }) {
  const [anchor, setAnchor] = useState(null);
  const [f, setF] = useState(from || "");
  const [t, setT] = useState(to || "");
  const open = Boolean(anchor);

  const apply = () => {
    onChange?.({ from: f || null, to: t || null });
    setAnchor(null);
  };
  const preset = (p) => {
    const today = new Date();
    let start, end;
    if (p.custom) { [start, end] = p.custom(today); }
    else if (p.days === 0) { start = today; end = today; }
    else { start = new Date(today.getTime() - p.days * 86400000); end = today; }
    const nf = fmt(start); const nt = fmt(end);
    setF(nf); setT(nt);
    onChange?.({ from: nf, to: nt });
    setAnchor(null);
  };

  const label = from && to ? `${from} → ${to}` : "Date range";

  return (
    <>
      <Button size="small" variant="outlined" startIcon={<CalendarMonthIcon />} onClick={(e) => setAnchor(anchor ? null : e.currentTarget)}>
        {label}
      </Button>
      <Popper open={open} anchorEl={anchor} placement="bottom-start" sx={{ zIndex: 1300 }}>
        <ClickAwayListener onClickAway={() => setAnchor(null)}>
          <Paper sx={{ p: 2, mt: 1, minWidth: 320 }}>
            <Stack spacing={1.5}>
              {sortByLabel(PRESETS).map((p) => (
                <MenuItem key={p.label} onClick={() => preset(p)} sx={{ borderRadius: 1, py: 0.5, px: 1 }}>{p.label}</MenuItem>
              ))}
              <Stack direction="row" spacing={1}>
                <TextField size="small" type="date" label="From" InputLabelProps={{ shrink: true }} value={f} onChange={(e) => setF(e.target.value)} />
                <TextField size="small" type="date" label="To" InputLabelProps={{ shrink: true }} value={t} onChange={(e) => setT(e.target.value)} />
              </Stack>
              <Stack direction="row" justifyContent="flex-end" spacing={1}>
                <Button size="small" onClick={() => setAnchor(null)}>Cancel</Button>
                <Button size="small" variant="contained" onClick={apply}>Apply</Button>
              </Stack>
            </Stack>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
